import * as React from 'react';
import { SVGProps } from 'react';

export const CalendarIconAssignmentSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M4.5 14.5H12C13.1046 14.5 14 13.6046 14 12.5V4.5L11 1.5H4.5C3.39543 1.5 2.5 2.39543 2.5 3.5V12.5C2.5 13.6046 3.39543 14.5 4.5 14.5Z"
            stroke="#3B516A"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M5.5 6.5H8.5"
            stroke="#3B516A"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.5 10.5H11"
            stroke="#3B516A"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 1.5V4.5C10.5 5.05228 10.9477 5.5 11.5 5.5H14.5"
            stroke="#3B516A"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
    </svg>
);

export const CalendarIconQuizSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M13 2.5H3C1.89543 2.5 1 3.39543 1 4.5V11.5C1 12.6046 1.89543 13.5 3 13.5H13C14.1046 13.5 15 12.6046 15 11.5V4.5C15 3.39543 14.1046 2.5 13 2.5Z"
            stroke="#3B516A"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="8" cy="8" r="2.375" stroke="#3B516A" strokeWidth="1.25" />
        <path
            d="M8.5 8.49997L10.5 10.5"
            stroke="#3B516A"
            strokeWidth="1.25"
            strokeLinecap="round"
        />
    </svg>
);
